var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomFieldEditActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161058",
    "data-name": "Group 161058",
    transform: "translate(-640 -840)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140354",
    "data-name": "Rectangle 140354",
    width: 33,
    height: 29,
    rx: 6,
    transform: "translate(640 840)",
    fill: "#e0f0fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Edit_18",
    transform: "translate(649.335 847.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(0 0.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 14,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 14,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(0.637 0.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M7.482,4H3.218A1.218,1.218,0,0,0,2,5.218v8.527a1.218,1.218,0,0,0,1.218,1.218h8.527a1.218,1.218,0,0,0,1.218-1.218V9.482",
    transform: "translate(-2 -2.237)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M15.7,3.411A1.763,1.763,0,0,1,18.189,5.9l-5.8,5.905-3.325.831.831-3.325Z",
    transform: "translate(-5.012 -3.879)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFieldEditActiveIcon);
export default __webpack_public_path__ + "static/media/custom-field-edit-active-icon.f5bbb293dba6adbb56058aeaf2434bcf.svg";
export { ForwardRef as ReactComponent };